module.exports = __webpack_public_path__ + "img/icon_switch_left.60f84416.png";